import {
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAILURE,
  CREATE_PRODUCT_REQUEST,
  CREATE_PRODUCT_SUCCESS,
  CREATE_PRODUCT_FAILURE,
  UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_SUCCESS,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_REQUEST,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_FAILURE,
  GET_LOW_STOCK_REQUEST,
  GET_LOW_STOCK_SUCCESS,
  GET_LOW_STOCK_FAILURE,
} from '../types';
import api from '../../services/api';

// Get all products
export const getProducts = (params = {}) => async (dispatch) => {
  try {
    dispatch({ type: GET_PRODUCTS_REQUEST });

    const response = await api.get('/master/products', { params });
    const data = response.data.data;

    dispatch({
      type: GET_PRODUCTS_SUCCESS,
      payload: data,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get products';
    dispatch({
      type: GET_PRODUCTS_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Create product
export const createProduct = (productData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_PRODUCT_REQUEST });

    const response = await api.post('/master/products', productData);
    const product = response.data.data;

    dispatch({
      type: CREATE_PRODUCT_SUCCESS,
      payload: product,
    });

    return { success: true, data: product };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to create product';
    dispatch({
      type: CREATE_PRODUCT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Update product
export const updateProduct = (id, productData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PRODUCT_REQUEST });

    const response = await api.put(`/master/products/${id}`, productData);
    const product = response.data.data;

    dispatch({
      type: UPDATE_PRODUCT_SUCCESS,
      payload: product,
    });

    return { success: true, data: product };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to update product';
    dispatch({
      type: UPDATE_PRODUCT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Delete product
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_PRODUCT_REQUEST });

    await api.delete(`/master/products/${id}`);

    dispatch({
      type: DELETE_PRODUCT_SUCCESS,
      payload: id,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to delete product';
    dispatch({
      type: DELETE_PRODUCT_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};

// Get low stock products
export const getLowStockProducts = (threshold = 10) => async (dispatch) => {
  try {
    dispatch({ type: GET_LOW_STOCK_REQUEST });

    const response = await api.get('/master/products/low-stock', {
      params: { threshold }
    });
    const products = response.data.data;

    dispatch({
      type: GET_LOW_STOCK_SUCCESS,
      payload: products,
    });

    return { success: true };
  } catch (error) {
    const message = error.response?.data?.message || 'Failed to get low stock products';
    dispatch({
      type: GET_LOW_STOCK_FAILURE,
      payload: message,
    });
    return { success: false, message };
  }
};
